var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 58C45.0163 58 58 45.0163 58 29C58 12.9837 45.0163 0 29 0C12.9837 0 0 12.9837 0 29C0 45.0163 12.9837 58 29 58Z",
    fill: "#F9FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5208 36.7755L18.3885 28.7683L28.9081 14.9946C29.4682 14.2613 30.6023 14.3667 31.0177 15.1906L39.9089 32.8261C40.2967 33.5951 39.8087 34.5167 38.9547 34.6283L22.5208 36.7755Z",
    stroke: "#787395",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6638 32.7881C13.353 32.1716 13.6008 31.42 14.2173 31.1092L18.3752 29.0129L22.3778 36.9519L18.2199 39.0482C17.6034 39.359 16.8517 39.1112 16.541 38.4948L13.6638 32.7881Z",
    stroke: "#787395",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0073 38.2149L22.4016 37.0078L24.6141 41.3961C24.9249 42.0126 24.6771 42.7642 24.0607 43.075L23.8987 43.1567C23.2823 43.4675 22.5306 43.2197 22.2198 42.6032L21.3949 40.9671L20.0073 38.2149Z",
    stroke: "#787395",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1625 19.2724C36.7643 19.1587 36.5337 18.7435 36.6474 18.3453L37.4622 15.4937C37.576 15.0954 37.9911 14.8648 38.3894 14.9786C38.7876 15.0924 39.0183 15.5075 38.9045 15.9058L38.0897 18.7573C37.9759 19.1556 37.5608 19.3862 37.1625 19.2724Z",
    fill: "#787395"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0434 26.0999C41.0939 25.6888 41.4681 25.3964 41.8792 25.4468L44.8228 25.808C45.2339 25.8584 45.5263 26.2326 45.4758 26.6437C45.4254 27.0549 45.0512 27.3473 44.6401 27.2968L41.6965 26.9356C41.2854 26.8852 40.993 26.511 41.0434 26.0999Z",
    fill: "#787395"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0361 21.9414C39.8705 21.5617 40.0441 21.1197 40.4238 20.9542L46.2567 18.4111C46.6364 18.2456 47.0784 18.4192 47.2439 18.7989C47.4094 19.1786 47.2358 19.6206 46.8561 19.7861L41.0233 22.3292C40.6436 22.4947 40.2016 22.3211 40.0361 21.9414Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectLink);
export default __webpack_public_path__ + "static/media/connect-link.4fd02fb3.svg";
export { ForwardRef as ReactComponent };